import styled from '@emotion/styled';
import Dropdown from '../../assets/icon-arrow.inline.svg';
import { colors, dimensions } from '../../styles/variables';
import { Visibility } from '../../types';

export const Wrapper = styled.section<Visibility>`
  opacity: 0;
  max-width: 1110px;
  width: 100%;
  margin: 95px auto 93px auto;
  padding: 0 30px;
  transform: translateY(10%);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  ${({ isVisible }) =>
    isVisible &&
    `
    opacity: 1;
    transform: translateY(0);
  `}
`;

export const Heading = styled.header`
  margin-bottom: 55px;
  text-align: center;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${dimensions.fontSize.heading}px;
  line-height: ${dimensions.lineHeight.heading};
  font-weight: 900;
`;

export const Questions = styled.ul`
  display: grid;
  margin: 0 0 41px 0;
  padding: 0;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 30px;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const QuestionsColumn = styled.div``;

export const Question = styled.li`
  margin-bottom: 12px;
  list-style: none;
`;

export const QuestionTitle = styled.h3`
  margin: 0;
  padding: 10px 30px 10px 0;
  position: relative;
  font-size: ${dimensions.fontSize.medium}px;
  line-height: 1.3;
  font-weight: 900;
  cursor: pointer;
`;

export const QuestionDescription = styled.p`
  margin: 6px 0 22px 0;
  color: ${colors.lightGray};
  font-size: ${dimensions.fontSize.regular}px;
  line-height: 1.625;
`;

interface IconDropdownProps {
  isActive: boolean;
}

export const IconDropdown = styled(Dropdown)<IconDropdownProps>`
  width: 16px;
  height: 9px;
  position: absolute;
  top: 18px;
  right: -1px;

  ${({ isactive }) =>
    isactive &&
    `
      transform: rotate(180deg);
  `}

  path {
    fill: ${colors.navyBlue};
  }
`;
